import Api from '@/services/Api'

export default {
  // Partner po OIB-u: posluzitelj prvo gleda nase partnere, pa sudski registar.
  // Odgovor: {izvor: 'partner'|'sudreg'|null, partner, poruka}
  poOibu (query) {
    return Api().get('sudreg/pooibu', {
      params: query
    })
  },
  poNazivu (query) {
    return Api().get('sudreg/ponazivu', {
      params: query
    })
  },
  stanje () {
    return Api().get('sudreg/stanje')
  }
}
